
import { AssignMaterialsToPackagesController  } from './controllers/assignMaterialsToPackagesController';
import '../../models/requestDetailEdit';
import '../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import '../assignMaterialsToPackagesDialog/controllers/assignMaterialsToPackagesDialogController';
import './templates/assignMaterialsToPackages.scss';


export class AssignMaterialsToPackagesDirective implements angular.IDirective {
    template = require('./templates/assignMaterialsToPackages.html');
    restrict = 'E';
    controller = AssignMaterialsToPackagesController;
    controllerAs = 'vm';
    bindToController = {
        requestDetailEdit :"=",
        isFormRequestedFromAddNewRequest: '=',
        isValid : '='
    };
    scope = {};
    replace = true;
    static factory(): angular.IDirectiveFactory {
        return () => new AssignMaterialsToPackagesDirective();
    }
}

angular.module('deliveryCreate.app').directive('assignMaterialsToPackages', AssignMaterialsToPackagesDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/assignMaterialsToPackages/assignMaterialsToPackagesDirective.ts
 **/